import LTR from "@brand-icons/ploom/gift/gift-ltr.svg";
import RTL from "@brand-icons/ploom/gift/gift-rtl.svg";

import { iconFactory } from "../iconFactory";

export const GiftIcon = iconFactory("GiftIcon", LTR, RTL);
